import React from 'react';
import { Wrapper, Text, Checkmark } from './Styled';

export interface CheckboxProps {
  children?: string;
  onClick?: () => void;
  checked?: boolean;
}

const Checkbox = (props: CheckboxProps) => {
  const { children, checked, onClick } = props;

  return (
    <Wrapper>
      <Checkmark onClick={onClick} checked={checked} />
      <Text>{children}</Text>
    </Wrapper>
  );
};

export default Checkbox;
export { Checkbox };
